import { Button, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

export interface ActionButtonProps {
  text: string
  url: string
  isMobile: boolean
  onClickLink: () => void
  onClickNotInterested: () => void
}

const ActionButtons = ({
  text,
  url,
  isMobile,
  onClickLink,
  onClickNotInterested,
}: ActionButtonProps) => {
  const { t } = useTranslation()

  return (
    <Stack direction={isMobile ? 'column' : 'row'} spacing={1}>
      <Button
        data-testid="start-here-button"
        onClick={onClickLink}
        href={url}
        sx={{ width: isMobile ? '100%' : undefined }}
      >
        {text}
      </Button>
      <Button
        data-testid="not-interested-button"
        variant="text"
        onClick={onClickNotInterested}
        sx={{ width: isMobile ? '100%' : undefined }}
      >
        {t('translation:startHereBlock.notInterested')}
      </Button>
    </Stack>
  )
}

export default ActionButtons
